/* Frage-Formular (VS-20260923-001). Schickt das Formular als JSON an den Worker,
   zeigt Erfolg/Fehler im Formular an. Ohne JS postet das Formular normal; dann
   leitet der Worker zurueck auf page_url?frage=danke und dieser Code zeigt die
   Bestaetigung. Keine Abhaengigkeit von jQuery oder dem Theme-Bundle. */
(() => {
  'use strict';

  const TEXT_EN = {
    sending: 'Sending…',
    ok: 'Thank you! Your question has arrived. We’ll reply by email, usually within 1–2 working days.',
    invalid: 'Please check the highlighted fields.',
    tooMany: 'There have just been a lot of requests. Please try again in an hour or write to us at kontakt@viviannaschmuck.de.',
    fail: 'Sorry, that didn’t work. Please write to us directly at kontakt@viviannaschmuck.de and we’ll take care of it.',
  };

  const TEXT = /^en\b/i.test(document.documentElement.lang || '') ? TEXT_EN : {
    sending: 'Wird gesendet …',
    ok: 'Danke! Deine Frage ist angekommen. Wir antworten dir per E-Mail, in der Regel innerhalb von 1–2 Werktagen.',
    invalid: 'Bitte prüfe die markierten Felder.',
    tooMany: 'Das waren gerade sehr viele Anfragen. Bitte versuch es in einer Stunde noch einmal oder schreib uns an kontakt@viviannaschmuck.de.',
    fail: 'Das hat leider nicht geklappt. Schreib uns bitte direkt an kontakt@viviannaschmuck.de, wir kümmern uns.',
  };

  const banner = (status, text) => {
    const el = document.createElement('div');
    el.className = 'banner banner--' + status;
    el.setAttribute('role', status === 'error' ? 'alert' : 'status');
    el.textContent = text;
    return el;
  };

  const setStatus = (form, status, text) => {
    const box = form.querySelector('[data-viv-qa-status]');
    if (!box) return;
    box.replaceChildren(banner(status, text));
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  const showThanks = (form) => {
    const fieldset = form.querySelector('.fieldset');
    if (fieldset) fieldset.hidden = true;
    setStatus(form, 'success', TEXT.ok);
    form.dataset.done = '1';
  };

  const init = (form) => {
    if (form.dataset.vivQaInit) return;
    form.dataset.vivQaInit = '1';

    // Rueckkehr nach No-JS-POST (Worker leitet auf ?frage=danke zurueck).
    if (new URLSearchParams(location.search).get('frage') === 'danke') {
      form.removeAttribute('hidden');
      showThanks(form);
    }

    form.addEventListener('submit', async (ev) => {
      const endpoint = form.dataset.endpoint;
      if (!endpoint || !window.fetch) return; // normales POST
      ev.preventDefault();
      if (form.dataset.done) return;
      if (!form.reportValidity()) { setStatus(form, 'error', TEXT.invalid); return; }

      const submit = form.querySelector('[data-viv-qa-submit]');
      const data = Object.fromEntries(new FormData(form).entries());
      data.page_url = location.href.split('#')[0];
      data.oeffentlich_ok = data.oeffentlich_ok ? '1' : '0';
      submit && (submit.disabled = true);
      setStatus(form, 'success', TEXT.sending);

      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(data),
        });
        if (res.ok) { showThanks(form); return; }
        if (res.status === 429) { setStatus(form, 'error', TEXT.tooMany); }
        else if (res.status === 400) {
          let msg = TEXT.invalid;
          try { const j = await res.json(); if (j && j.message) msg = j.message; } catch (e) { /* leer */ }
          setStatus(form, 'error', msg);
        } else { setStatus(form, 'error', TEXT.fail); }
      } catch (e) {
        setStatus(form, 'error', TEXT.fail);
      } finally {
        submit && (submit.disabled = false);
      }
    });
  };

  const boot = () => document.querySelectorAll('form[data-viv-qa-form]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
